import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from 'src/app/services/image.service';
import Swal from 'sweetalert2';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

    loading = false;
    loadingBtn = false;
    showPopup = false;
    modalBoxName = '';
    keyword = 'name';
    sno = 1;
    errorMsg: any = [];
    viewBox = false;
    showImage = true;
    show: boolean = false;
    defaultImage = 'assets/images/loader.gif';
    AboutUsDetails:any;
    banner_id:any;
    header: any;
    description:any;
    points: any;
    headerLogo: any;

    constructor(
        private apiService: ApiService,
        private toastr: ToastrService,
        public router: Router,
        private imageService: ImageService,
        private formBuilder: FormBuilder
    ){ }

    ngOnInit(){
        this.getAboutUs();
    }

    getAboutUs() {
        this.loading = true;
        this.apiService.getData('getAboutUs').subscribe((data) => {
            this.AboutUsDetails = data.data[0];
            this.banner_id = this.AboutUsDetails.id
            this.header = this.AboutUsDetails.header;
            this.description = this.AboutUsDetails.description;
            this.headerLogo = this.AboutUsDetails.image;
            this.loading = false;
        }, error => {
            this.loading = false;
        });
    }

    apiCall(name, url, value: any = '') {
        this.apiService[name](url, value).subscribe((data) => {
            if (data.error === false) {
                this.toastr.success(data.message);
                this.loadingBtn = false;
            } else {
                this.toastr.error(data.message);
                this.loadingBtn = false;
                this.errorMsg = data.data;
            }
            this.getAboutUs();
        });
    }

    updateHeader() {
        const value = {
            id: this.banner_id,
            header: this.header,
            description: this.description,
        }
        this.apiCall("update", "updateAboutUs", value);
    }

    closepopup() {
        this.show = false;
    }

    openPopup() {
        this.show = true;
    }
}
